/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sign: NonNullable<unknown> }} Placeholders_Inputmoney1Inputs */

const en_placeholders_inputmoney1 = /** @type {(inputs: Placeholders_Inputmoney1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sign} 0`)
};

/**
* | output |
* | --- |
* | "{sign} 0" |
*
* @param {Placeholders_Inputmoney1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const placeholders_inputmoney1 = /** @type {((inputs: Placeholders_Inputmoney1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeholders_Inputmoney1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_placeholders_inputmoney1(inputs)
});
export { placeholders_inputmoney1 as "placeholders_inputMoney" }